import store from '@/store'

const mixin = {
    methods:{
        formatEventName( name, edition ){
            console.log( name + " " + edition )
            return name + "'" + edition.substring(2);
        },
        formatEventUrl( name, edition ){
            console.log( name + " " + edition );
            return '/event/' + ( name + edition.substring(2) ).toLowerCase();
        },
        entityUrl( entity_name, id ){
            var event = ( store.getters.isEventSelected )? store.getters[ 'events/getCurrentEvent' ]() : false;
            var path = ( event )? this.formatEventUrl( event.name, event.edition ) : "";
            switch( entity_name ){
                case 'club': path+= '/club';
                            break;
                case 'team': path+= '/team';
                            break;
            }
            path+= '/card/' + id;

            return path;
        }
    }
}

export default mixin